import { useModalStyles } from "@saleor/autobooking/styles/modalStyles";
import React from "react";

export interface AutoBookingDialogFormProps {
  mallName: string;
  isFbTab: boolean;
  setIsFbTab: React.Dispatch<React.SetStateAction<boolean>>;
}

const AutoBookingDialogFormHeader: React.FC<AutoBookingDialogFormProps> = props => {
  const { mallName } = props;

  const classes = useModalStyles(props);

  return (
    <>
      <div className={classes.modalTitleContainerV2}>
        <p className={classes.modalTitleTextV2}>
          Edit Autobooking for {mallName}
        </p>
      </div>
    </>
  );
};

AutoBookingDialogFormHeader.displayName = "AutoBookingDialogFormHeader";
export default AutoBookingDialogFormHeader;
